import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

const TESTIMONIAL_ITEM_SCHEMA = [
  { key: "avatar", label: "Avatar Image", type: "image" as const },
  { key: "name", label: "Name", type: "string" as const },
  { key: "designation", label: "Designation", type: "string" as const },
  { key: "review", label: "Review Text", type: "text" as const },
  { key: "rating", label: "Rating (1–5)", type: "number" as const, default: 5 },
];

const PORTRAIT_ITEM_SCHEMA = [
  { key: "avatar", label: "Portrait photo", type: "image" as const, help: "Tall, about 800 × 1000 px (4:5)." },
  { key: "name", label: "Name", type: "string" as const },
  { key: "designation", label: "Role", type: "string" as const, help: "Shown after the name, e.g. “Musician”." },
];

export const schema: ComponentSchema = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer reviews and social proof section.",
  supportedPages: ["home", "shop"],
  variants: [
    {
      id: "v1",
      label: "Quote slider",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "What Our Customers Say" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: TESTIMONIAL_ITEM_SCHEMA },
      ],
    },
    {
      id: "v2",
      label: "Quote cards",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Customer Reviews" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: TESTIMONIAL_ITEM_SCHEMA },
      ],
    },
    {
      id: "v3",
      label: "Portrait carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Worn on our streets" },
        { key: "intro", label: "Intro line", type: "text", help: "Put *stars* around words to show them bold." },
        { key: "items", label: "People", type: "array", itemSchema: PORTRAIT_ITEM_SCHEMA },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
